import { Lato } from 'next/font/google';

const font = Lato({
  variable: '--primary-font',
  weight: ['100', '300', '400', '700', '900'],
  subsets: ['latin'],
});

const Fonts = () => {
  return (
    <style jsx global>
      {`
        :root {
          --primary-font: ${font.style.fontFamily};
        }
      `}
    </style>
  );
};

export default Fonts;
